// Centralized hero content per service slug
// Each entry defines a "title" (shown as "{title} Solution"), a single-line typingTexts array, and per-page bullets

export const heroContentBySlug = {
  "software-development": {
    title: "Software Development",
    typingTexts: ["Ship High‑Quality Software, Faster"],
    bullets: [
      "End‑to‑End Product Engineering",
      "Agile Delivery & CI/CD",
      "Scalable Microservices & APIs",
      "Cloud‑Native & Containerized",
      "QA Automation & Code Quality",
      "Maintenance & Support",
    ],
  },
  "api-development": {
    title: "API Development",
    typingTexts: ["Secure, Scalable APIs That Just Work"],
    bullets: [
      "REST & GraphQL APIs",
      "Auth, Rate Limiting, Throttling",
      "API Gateways & Documentation",
      "Third‑Party Integrations",
      "Monitoring & Observability",
      "Versioning & Compatibility",
    ],
  },
  "custom-software-integration": {
    title: "Custom Integration",
    typingTexts: ["Seamlessly Connect Your Systems"],
    bullets: [
      "iPaaS & ETL Pipelines",
      "ERP/CRM/Accounting Integrations",
      "Real‑time Webhooks & Events",
      "Data Mapping & Transformation",
      "Secure Auth (OAuth2, SSO)",
      "Resilience & Retry Queues",
    ],
  },
  "website-development": {
    title: "Website Development",
    typingTexts: ["Lightning‑Fast, SEO‑Ready Websites"],
    bullets: [
      "Custom Web Design & Development",
      "Creative UX/UI and SEO Optimised Design",
      "Responsive and Mobile First Website",
      "Integration and Migration",
      "Secure and Robust Development",
      "Ongoing Support and Maintenance",
    ],
  },
  "ecommerce-development": {
    title: "eCommerce Development",
    typingTexts: ["Convert More with Powerful eCommerce"],
    bullets: [
      "Headless Commerce Architecture",
      "Payment Gateways & Subscriptions",
      "Catalog, Cart & Checkout",
      "OMS/WMS/ERP Integrations",
      "Performance & SEO",
      "Analytics & Conversion (CRO)",
    ],
  },
  "multi-vendor-ecommerce": {
    title: "Multi‑Vendor eCommerce",
    typingTexts: ["Build and Scale Multi‑Vendor Marketplaces"],
    bullets: [
      "Seller Onboarding & KYC",
      "Commission Rules & Payouts",
      "Catalog & Inventory Sync",
      "Order Routing & Splits",
      "Disputes & Returns Management",
      "Admin Dashboards & Reporting",
    ],
  },
  "cloud-solutions": {
    title: "Cloud Solutions",
    typingTexts: ["Migrate, Modernize, and Optimize in the Cloud"],
    bullets: [
      "Cloud Migrations (AWS/Azure/GCP)",
      "Kubernetes & Serverless",
      "IaC (Terraform/CDK/Bicep)",
      "Monitoring & Cost Optimization",
      "Security & Compliance",
      "Backup & Disaster Recovery",
    ],
  },
  "game-development": {
    title: "Game Development",
    typingTexts: ["Build Immersive Games Players Love"],
    bullets: [
      "Gameplay & Level Design",
      "Cross‑Platform (PC/Mobile/Web)",
      "Multiplayer & Leaderboards",
      "Monetization & Live Ops",
      "Graphics & Performance Tuning",
      "QA & Deployment",
    ],
  },
  "crm-solutions": {
    title: "CRM Solutions",
    typingTexts: ["Accelerate Growth with a CRM That Fits"],
    bullets: [
      "Custom CRM Development",
      "Implementation & Consulting",
      "Integrations & Automation",
      "Migrations & Upgrades",
      "Analytics & Dashboards",
      "Security & Compliance",
    ],
  },
  "mobile-app-development": {
    title: "Mobile App Development",
    typingTexts: ["Delightful iOS, Android & Cross‑Platform Apps"],
    bullets: [
      "iOS & Android Native Apps",
      "React Native & Flutter",
      "PWAs with Offline Support",
      "App Store & Play Release",
      "Analytics & Crash Reporting",
      "CI/CD & Performance Tuning",
    ],
  },
  "erp-next": {
    title: "ERPNext",
    typingTexts: ["Implement, Customize, and Scale ERPNext"],
    bullets: [
      "Implementation & Module Setup",
      "Customization & Scripting",
      "Integrations & Automation",
      "Migrations & Upgrades",
      "Training & Support",
      "Analytics & Dashboards",
    ],
  },
  "document-management-system": {
    title: "Document Management System",
    typingTexts: ["Capture, Organize, and Automate Documents"],
    bullets: [
      "Custom DMS Development",
      "Secure Cloud & On‑Prem",
      "OCR, Indexing & Search",
      "Integrations (ERP/CRM/Drive)",
      "Compliance & Governance",
      "Automation & Workflows",
    ],
  },
  "ai-ml": {
    title: "AI & Machine Learning",
    typingTexts: ["Build Intelligent, Production‑Ready AI Systems"],
    bullets: [
      "Custom AI/ML Development",
      "LLM Integrations & RAG",
      "NLP & Computer Vision",
      "MLOps & Model Monitoring",
      "Data Engineering & Pipelines",
      "AI Strategy & Consulting",
    ],
  },
  "ai-call-agent": {
    title: "AI Call Agent",
    typingTexts: ["Automate Calls with Voice AI"],
    bullets: [
      "Inbound & Outbound Voice Agents",
      "CRM & Calendar Integrations",
      "Real‑time Transcripts & Analytics",
      "Knowledge Base & Guardrails",
      "Compliance, Security & QA",
      "Custom Flows & Actions",
    ],
  },
  "ai-chat-bot": {
    title: "AI Chat Bot",
    typingTexts: ["Conversational AI that converts and supports"],
    bullets: [
      "Multi-channel experiences",
      "RAG-powered knowledge",
      "Deep CRM and API integrations",
    ],
  },
  hosting: {
    title: "Hosting",
    typingTexts: ["Managed, Secure, Always‑On Hosting"],
    bullets: [
      "Uptime SLAs & Monitoring",
      "Backups & Disaster Recovery",
      "Security & Compliance",
      "Cost Optimization",
      "Incident Response",
      "Scalable Infrastructure",
    ],
  },
  "server-support": {
    title: "Server Support",
    typingTexts: ["Proactive Server Management & Support"],
    bullets: [
      "Provisioning & Hardening",
      "Monitoring & Patching",
      "Disaster Recovery",
      "Performance Tuning",
      "Security & Compliance",
      "24/7 On‑Call",
    ],
  },
  "development-support": {
    title: "Development Support",
    typingTexts: ["Accelerate Delivery with Expert Support"],
    bullets: [
      "Team Augmentation",
      "Code Audits & QA",
      "CI/CD & Tooling",
      "Documentation & Onboarding",
      "Project Rescue",
      "SLA‑backed Support",
    ],
  },
  "staff-augmentation": {
    title: "Staff Augmentation",
    typingTexts: ["Scale Your Team with Vetted Talent"],
    bullets: [
      "Dedicated Developers",
      "Specialist Roles (QA/DevOps/Design)",
      "Flexible Engagements",
      "Rapid Onboarding",
      "Quality & Security",
      "Outcome‑Driven",
    ],
  },
  "digital-fulfilment": {
    title: "Digital Fulfilment",
    typingTexts: ["On‑Demand Digital Operations at Scale"],
    bullets: [
      "Content & Catalog Ops",
      "Campaign Execution",
      "Data Operations",
      "SLA & Governance",
      "On‑Demand Capacity",
      "Analytics & Reporting",
    ],
  },
  "it-support-services": {
    title: "IT Support Services",
    typingTexts: ["Reliable IT Operations Backed by SLAs"],
    bullets: [
      "Helpdesk & Endpoint Management",
      "Networking & Security",
      "Identity & Access",
      "Collaboration Suites",
      "Monitoring & Reporting",
      "Policies & Compliance",
    ],
  },
  devops: {
    title: "DevOps",
    typingTexts: ["Ship Faster with Reliable DevOps"],
    bullets: [
      "CI/CD & Environments",
      "Infrastructure as Code",
      "Kubernetes & Containers",
      "Observability & SLOs",
      "Security & Policies",
      "SRE & Operations",
    ],
  },
  seo: {
    title: "SEO",
    typingTexts: ["Grow Organic Traffic & Conversions"],
    bullets: [
      "Technical SEO",
      "On‑Page & Off‑Page",
      "Local SEO",
      "Analytics & Reporting",
      "Content Operations",
      "Site Architecture",
    ],
  },
  "social-media-marketing": {
    title: "Social Media Marketing",
    typingTexts: ["Build and Scale Your Social Presence"],
    bullets: [
      "Strategy & Calendars",
      "Content Production",
      "Community & Growth",
      "Analytics & Dashboards",
      "Always‑On Operations",
      "Governance & Playbooks",
    ],
  },
  "paid-ads-ppc": {
    title: "Paid Ads & PPC",
    typingTexts: ["Performance Marketing with Predictable ROI"],
    bullets: [
      "Account Setup & Tracking",
      "Campaigns & Creatives",
      "Optimization & Audiences",
      "Landing Pages & CRO",
      "Budgeting & Bidding",
      "Reporting & Insights",
    ],
  },
  orm: {
    title: "ORM",
    typingTexts: ["Protect and Improve Your Online Reputation"],
    bullets: [
      "Monitoring & Alerts",
      "Response & Playbooks",
      "Positive Content & PR",
      "Crisis & Recovery",
      "Analytics & SOV",
      "Governance & Compliance",
    ],
  },
  "performance-optimization": {
    title: "Performance Optimization",
    typingTexts: ["Make Your Product Fast and Scalable"],
    bullets: [
      "Audits & Profiling",
      "Frontend & Backend Tuning",
      "Infra Optimization",
      "Monitoring & Alerts",
      "Budgets & Guardrails",
      "CI & Regression Tests",
    ],
  },
};

// Aliases to handle directory naming mismatches and route mapping
heroContentBySlug["pay-per-click"] = heroContentBySlug["paid-ads-ppc"];
heroContentBySlug["dmsdocument-management-system"] = heroContentBySlug["document-management-system"];
heroContentBySlug["aiml"] = heroContentBySlug["ai-ml"];
heroContentBySlug["multyvendor-e-commerce"] = heroContentBySlug["multi-vendor-ecommerce"];

export function getHeroContentFromPath(pathname = "") {
  // expected patterns: /services, /services/<slug>
  const parts = pathname.split("/").filter(Boolean);
  const servicesIdx = parts.indexOf("services");
  const slug = servicesIdx >= 0 ? parts[servicesIdx + 1] : undefined;
  if (slug && heroContentBySlug[slug]) return heroContentBySlug[slug];
  // default for /services (overview) or unknown path
  return {
    title: "Our Services",
    typingTexts: ["Build Fast. Scale Smart."],
    bullets: [
      "Custom Web & App Development",
      "API Integrations & Automation",
      "Cloud‑Native & DevOps",
      "Secure, Scalable Architecture",
      "Performance & SEO",
      "Ongoing Support & Maintenance",
    ],
  };
}
